const isOutOfRange = (itemData) => {
    const now = new Date().getTime()

    return  (itemData.displayDateStart && new Date(itemData.displayDateStart).getTime() >= now) ||
            (itemData.displayDateEnd && now >= new Date(itemData.displayDateEnd).getTime())

}

export default isOutOfRange